import { ListItem } from './ListItem'

import * as styles from './StatisticSummaryTab.module.css'

function StatisticSummaryTab({ data }) {
  return (
    <table className={styles.table}>
      <tbody className={styles.tbody}>
        {data.map(i => (
          <ListItem item={i} key={i.name} />
        ))}
      </tbody>
    </table>
  )
}

export default StatisticSummaryTab
